import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ModalController, ToastController } from '@ionic/angular';
import { OverlayEventDetail } from '@ionic/core';
import { AppointmentInventory } from 'src/app/core/models/appointment-inventory.model';
import { InventoryAttribute } from 'src/app/core/models/inventory.model';
import { AppointmentService } from 'src/app/core/services/appointment/appointment.service';
import { InventoryService } from 'src/app/core/services/inventory/inventory.service';
import { TicketProvisioningService } from 'src/app/core/services/ticket-provisioning/ticket-provisioning.service';
import { EditInventoryComponent } from '../edit-inventory/edit-inventory.component';
import { RemoveInventoryComponent } from '../remove-inventory/remove-inventory.component';

@Component({
	selector: 'app-inventory-item',
	templateUrl: './inventory-item.component.html',
	styleUrls: ['./inventory-item.component.scss'],
})
export class InventoryItemComponent implements OnInit {

	@Input()
	item: AppointmentInventory;

	@Input()
	index: number;

	@Input()
	isExpanded: boolean;

	@Output()
	toggledSection = new EventEmitter<number>();

	isReadOnly: boolean;

	constructor(
		private modalController: ModalController,
		private activatedRoute: ActivatedRoute,
		private appointmentService: AppointmentService,
		private inventoryService: InventoryService,
		private toastController: ToastController,
		private ticketProvisioningService: TicketProvisioningService,
	) { }

	ngOnInit(): void {
		const hasBeenRemoved = (this.item.statusId != 1 &&
			this.item.statusId != 5 &&
			this.item.originalStatusId == 1);
		const isNewItem = this.item.id == 0;

		this.isReadOnly = isNewItem || hasBeenRemoved;
	}

	onClickToggleSection() {
		this.toggledSection.emit(this.index);
	}

	async onClickShowEditInventory(): Promise<any> {
		const appointment = await this.getCurrentAppointment();
		const modal = await this.modalController.create({
			component: EditInventoryComponent,
			componentProps: {
				inventoryItem: this.item,
				appointment
			},
			cssClass: 'full-screen-modal',
		});

		await modal.present();
		const response = (await modal.onDidDismiss()) as OverlayEventDetail<{
			dismissed?: boolean;
			inventoryUpdates: InventoryAttribute[]
		}>;

		const inventoryUpdates = response?.data?.inventoryUpdates;
		if (inventoryUpdates && inventoryUpdates.length > 0) {
			this.updateInventoryAttributes(inventoryUpdates);
		}
	}

	async onClickSetActive(): Promise<void> {
		const apptId = Number(this.activatedRoute.snapshot.parent.parent.params?.id);

		await this.inventoryService.setInventoryStatusToActive(apptId, this.item.id);
		await this.ticketProvisioningService.addProvision(apptId, this.item);
		await this.toastSetActiveSuccess();
	}

	private async getCurrentAppointment() {
		const apptId = this.activatedRoute.snapshot.parent.parent.params?.id;
		return await this.appointmentService.getLocalAppointment(apptId);
	}

	async onClickShowRemoveInventory(): Promise<any> {
		const modal = await this.modalController.create({
			component: RemoveInventoryComponent,
			componentProps: {
				inventoryItem: this.item,
				appointmentId: Number(this.activatedRoute.snapshot.parent.parent.params?.id),
			},
			cssClass: 'full-screen-modal',
		});

		await modal.present();
		await modal.onDidDismiss();
	}

	private async updateInventoryAttributes(inventoryUpdates: InventoryAttribute[]) {
		const appointment = await this.getCurrentAppointment();
		const inventoryItem = appointment.inventory.find(i => i.id === this.item.id);
		inventoryUpdates.forEach(u => {
			const attribute = inventoryItem.attributes.find(a => a.id === u.id);
			attribute.value = u.value;
		});

		this.item = inventoryItem;
		await this.appointmentService.saveLocalAppointment(appointment);
	}

	private async toastSetActiveSuccess(): Promise<void> {
		const toast = await this.toastController.create({
			message: 'Successfully set inventory active.',
			duration: 3000,
			position: 'top',
			color: 'success',
			buttons: ['Dismiss'],
		});

		await toast.present();
	}
}
